import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-commin-soon',
  templateUrl: './admin-commin-soon.component.html',
  styleUrls: ['./admin-commin-soon.component.css'],standalone:false
})
export class AdminComminSoonComponent {

}
